import { BuildingOffice2Icon } from "@heroicons/react/24/outline";

import { SoftText } from "@/components/text/SoftText";

export function CompanyAddress() {
  return (
    <div className="flex items-center gap-3">
      <BuildingOffice2Icon className="h-12 w-12" />
      <address className="pl-4 not-italic">
        <SoftText elementType="p">Audimee AB</SoftText>
        <SoftText elementType="p">Solrosgatan 4C</SoftText>
        <SoftText elementType="p">582 49 Linköping</SoftText>
        <SoftText elementType="p">Sweden</SoftText>
      </address>
    </div>
  );
}
